import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionDirective } from './subscription.directive';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscriptionService } from './subscription.service';
import { CdkStepperModule } from '@angular/cdk/stepper';



@NgModule({
  declarations: [SubscriptionDirective],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    CdkStepperModule
  ],
  exports: [SubscriptionDirective],
  providers: [SubscriptionService]
})
export class SubscriptionModule { }
